module.exports = {
	"projects": {
		"fq": {
			"title": "Fetch Quest",
			"text": [
				"Errand gamification mobile app.",
				"Angular, Ionic, Rails, SQL and Google Maps API.",
				"Focused on building out the map UI/UX and geolocation functionality. Designed and built out the Api and associated test suite for controlling continuous integration."
			],
			"image": "fq_modal.jpeg",
			"links": [
				{
					"url": "https://github.com/rrichardsonv/fetch-quest-mobile",
					"display": "Mobile Codebase"
				},
				{
					"url": "https://github.com/rrichardsonv/fetch-quest",
					"display": "Api Codebase"
				}
			]
		},
		"cb": {
			"title": "Crew Battle",
			"text": [
				"SSB4 Format Web Tool",
				"React, Redux",
				"Currently in the process of playtesting. Built as a tool to enable additional formats for tournaments hosted by iCon Tournaments."
			],
			"image": "cb_modal.jpeg",
			"links": [
				{
					"url": "https://github.com/rrichardsonv/crew-battle",
					"display": "Codebase"
				},
				{
					"url": "https://crew-battle.herokuapp.com",
					"display": "Beta Site"
				}
			]
		},
		"sh": {
			"title": "Shovlin",
			"text": [
				"Shared bookmarks Chrome Extension",
				"Javascript, Rails, SQL",
				"Chrome Extension to turn a bookmarks folder into a shared Stumbleupon."
			],
			"image": "shovelin_screenshot.jpeg",
			"links": [
				{
					"url": "https://github.com/rrichardsonv/shovelin",
					"display": "Extension Codebase"
				},
				{
					"url": "https://github.com/rrichardsonv/shared-stumble-api",
					"display": "Api Codebase"
				}
			]
		},
		"sm": {
			"title": "Sonnet Maker",
			"text": [
				"Natural Language Generation CLI",
				"Python3, NLTK",
				"Focused on implementing simple grammar in this deep dive into the linguistic fever dream that is the English language. First minor foray into Python3 and the amazing depth in NLG"
			],
			"image": "sonnet_maker.jpeg",
			"links": [
				{
					"url": "https://github.com/rrichardsonv/sonnet-maker",
					"display": "Codebase"
				}
			]
		},
		"sk": {
			"title": "Skycast",
			"text": [
				"Weather forecasting app",
				"React, Redux, D3, Node, Rails, SQl, Darksky Api, Google Geocoding Api",
				"Weather charts for current and future forecast data. Split responsibilities for planned move to React Native."
			],
			"image": "sk_modal.jpeg",
			"links": [
				{
					"url": "https://github.com/rrichardsonv/skycast-proto2",
					"display": "Client Codebase"
				},
				{
					"url": "https://github.com/rrichardsonv/skycast-api",
					"display": "Proxy Codebase"
				},
				{
					"url": "https://skycast-proto.herokuapp.com",
					"display": "Site"
				}
			]
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/modals.json
// module id = 134
// module chunks = 0